// Backend Base Url
export const BACKEND_BASE_URL = window.env.BACKEND_BASE_URL ?? "";
export const IMAGE_HOST = window.env.IMAGE_HOST ?? "";
export const PUSHER_APP_KEY = window.env.PUSHER_APP_KEY ?? "";
export const POLICY_ENABLE = window.env.POLICY_ENABLE ?? true;

// HotelNXT Base Url
export const HOTELNXT_BASE_URL = window.env.HOTELNXT_BASE_URL ?? "";
export const HOTELNXT_API_URL = HOTELNXT_BASE_URL + "/api";
export const VENDOR_BILL_DETAIL =
  HOTELNXT_API_URL + "/vendor/bill/by-hotelcode";
export const BILL_RZP_LINK_GEN =
  HOTELNXT_API_URL + "/vendor/bill/transaction/razorpay/link";

// -----------------------
// MediaBase Url
export const PROJECT_MEDIA_FOLDER = "hotel";
export const IMAGE_BASE_URL = IMAGE_HOST + "/" + PROJECT_MEDIA_FOLDER + "/";
// -----------------------
// SubPath
export const API_URL = BACKEND_BASE_URL + "/api";

// PDF Path
export const BOOKING_QR_PASS = BACKEND_BASE_URL + "/booking-pass/";
export const BOOKING_INVOICE = API_URL + "/booking/invoice?id=";
// WhatsApp recharge receipt (full URL; opened in a new tab like booking invoice)
export const WHATSAPP_RECHARGE_RECEIPT = API_URL + "/whatsapp/recharge/receipt?id=";
export const BOOKING_MULTI_INVOICE = API_URL + "/booking/multi-invoice?id=";
export const KITCHEN_PDF_ISSUE_REPORT = API_URL + "/kitchen/report/issue-pdf";
export const KITCHEN_PDF_STOCK_REPORT =
  API_URL + "/kitchen/report/stock-report/pdf-view?id=";
export const KITCHEN_PURCHASE_RETURN_PDF = API_URL + "/kitchen/report/purchase-return-pdf";

// External Server File-Upload API
export const EX_FILE_UPLOAD = IMAGE_HOST + "/api/fileSave";
export const EX_FILE_DESTROY = IMAGE_HOST + "/api/fileDestroy";

// Location API
export const LOCATIONS = "locations?country_id=";

// File-Upload API
export const ALL_UPLOADED_FILE = "files/folder-wise";
export const FOLDERS = "files/folders";
export const FILES_BY_FOLDER = "files/by-folder";
export const FILE_UPLOAD = "files/multi_upload";
export const FILE_UPDATE = "files/update";
export const FILE_DESTROY = "files/delete";

// Auth API
export const LOGIN = "login";
export const REGISTER = "register";
export const SENT_OTP = "mail-verification";
export const VERIFY_OTP = "forgot-password";
export const DASH_DATA = "dashboard-data";
export const DASH_DATA_V2 = "dashboard-data-v2?week=";

// User Wallet API
export const USER_WALLET_HISTORY = "userWalletHistory";
export const USER_WALLET_HISTORY_CREATE = "createWalletHistory";

// User API
export const USER = "user/customer";
export const STAFF = "user/staff";
export const USER_DETAIL = "user/by_id";
export const USER_DETAIL_MOBILE = "user/by_mobile";
export const ADD_USER = "user/create";
export const EDIT_USER = "user/update";
export const DELETE_USER = "user/delete";

// Customer API
export const MY_BOOKING = "customer/bookings";

// SEO API
export const ALL_SEO = "seo";
export const SEO_BY_ID = "seo/detail";
export const CREATE_SEO = "seo/create";
export const EDIT_SEO = "seo/update";
export const DELETE_SEO = "seo/destroy";

// Category API
export const ALL_CATEGORY = "category";
export const ROOM_CATEGORY = "category/room";
export const PRODUCT_CATEGORY = "category/product";
export const CATEGORY_BY_ID = "category/detail";
export const CREATE_CATEGORY = "category/create";
export const EDIT_CATEGORY = "category/update";
export const DELETE_CATEGORY = "category/destroy";

// Facility API
export const ALL_FACILITY = "facility";
export const FACILITY_BY_TYPE = "facility/type";
export const FACILITY_BY_ID = "facility/detail";
export const CREATE_FACILITY = "facility/create";
export const EDIT_FACILITY = "facility/update";
export const DELETE_FACILITY = "facility/destroy";

// Extra Service API
export const ALL_SERVICE = "service";
export const SERVICE_BY_ID = "service/detail";
export const CREATE_SERVICE = "service/create";
export const EDIT_SERVICE = "service/update";
export const DELETE_SERVICE = "service/destroy";

// Contacts API
export const ALL_CONTACTS = "contact";
export const DELETE_CONTACTS = "contact/destroy";

// Blog/News API
export const ALL_BLOG = "blog";
export const BLOG_BY_ID = "blog/detail";
export const CREATE_BLOG = "blog/create";
export const EDIT_BLOG = "blog/update";
export const DELETE_BLOG = "blog/destroy";

// QR Sharing API
export const ALL_QR_SHARING = "qr-sharing";
export const QR_SHARING_LOGO_BASE64 = "qr-sharing/logo-base64";
export const QR_SHARING_BY_ID = "qr-sharing/detail";
export const CREATE_QR_SHARING = "qr-sharing/create";
export const EDIT_QR_SHARING = "qr-sharing/update";
export const DELETE_QR_SHARING = "qr-sharing/destroy";

// Gallery API
export const ALL_GALLERY = "gallery";
export const GALLERY_BY_ID = "gallery/detail";
export const CREATE_GALLERY = "gallery/create";
export const EDIT_GALLERY = "gallery/update";
export const DELETE_GALLERY = "gallery/destroy";

// Team API
export const ALL_TEAM = "team";
export const TEAM_BY_ID = "team/detail";
export const CREATE_TEAM = "team/create";
export const EDIT_TEAM = "team/update";
export const DELETE_TEAM = "team/destroy";

// Testimonial API
export const ALL_TESTIMONIAL = "testimonial";
export const TESTIMONIAL_BY_ID = "testimonial/detail";
export const CREATE_TESTIMONIAL = "testimonial/create";
export const EDIT_TESTIMONIAL = "testimonial/update";
export const DELETE_TESTIMONIAL = "testimonial/destroy";

// Dynamic Content  API
export const ALL_DYNAMIC_CONTENT = "pages";
export const DYNAMIC_CONTENT_LIST = "pages-list";
export const DYNAMIC_CONTENT_BY_ID = "pages/detail";
export const CREATE_DYNAMIC_CONTENT = "pages/create";
export const EDIT_DYNAMIC_CONTENT = "pages/update";
export const DELETE_DYNAMIC_CONTENT = "pages/destroy";

// Slider-Banner  API
export const ALL_SLIDER = "slider";
export const SLIDER_BY_ID = "slider/detail";
export const CREATE_SLIDER = "slider/create";
export const EDIT_SLIDER = "slider/update";
export const DELETE_SLIDER = "slider/destroy";

// Common Booking API
export const BOOKING_ROOMS = "booking/rooms";
export const BOOKING_ROOMS_AVL = "booking/check-room-availability";
export const BOOKING_PAYMENT = "booking/init-pay";
export const BOOKING_STORE = "booking/store";

// Room API
export const ALL_ROOMS = "room";
export const ROOMS_BY_ID = "room/detail";
export const CREATE_ROOMS = "room/create";
export const EDIT_ROOMS = "room/update";
export const EDIT_ROOMS_BY_GROUP = "room/update/by-group";
export const DELETE_ROOMS = "room/destroy";
export const EDIT_STATUS_ROOMS = "room/status/update";
export const EDIT_GROUP_ID = "room/group/update";
export const GENERATE_GROUP_ID = "room/generate-group-id";

// Room Blocked API
export const ROOM_BLOCKED = "room-block/by-room";
export const ROOM_BLOCKED_BY_ID = "room-block/detail";
export const CREATE_ROOM_BLOCKED = "room-block/create";
export const EDIT_ROOM_BLOCKED = "room-block/update";
export const DELETE_ROOM_BLOCKED = "room-block/destroy";

// Booking API
export const ALL_BOOKING = "booking?type=";
export const BOOKINGS = "booking";
export const BOOKINGS_COMPLETED = "booking/completed-bookings";

export const BOOKING_LOG = "booking/logs";
export const BOOKING_SERVICE = "booking/extra-services";
export const DELETE_EXTRA_SERVICE = "booking/services-destroy";
export const GUESTS_BOOKINGS = "booking/guest";
export const BOOKING_CALENDER = "booking/calendar-events";
export const BOOKING_CALENDER_V2 = "booking/calendar-events-v2";
export const BOOKING_FOOTER = "booking/footer-stats";
export const ROOM_VIEW = "booking/room-view";
export const BOOKING_BY_ID = "booking/detail";
export const CREATE_BOOKING = "booking/create";
export const EDIT_BOOKING = "booking/update";
export const BOOKING_CHECKOUT = "booking/checkout";
export const BOOKING_CHECKIN = "booking/checkin";
export const BOOKING_ACTION = "booking/accept_reject";
export const BOOKING_ADV_PAY = "booking/advance_payment";
export const BOOKING_ADV_PAY_VERIFY = "booking/advance_pay_verify";
export const BOOKING_PAY = "booking/pay";
export const BOOKING_PAY_VERIFY = "booking/pay_verify";
export const BOOKING_ASSIGN_UNASSIGN = "booking/assign-unassign";
export const BOOKING_APPLY_SERVICE = "booking/apply-service";
export const BOOKING_REGEN_INV_GRC = "booking/regenrate-invoice-grc";

// Booking Refund API
export const ALL_BOOKING_REFUND = "booking-refund";
export const BOOKING_REFUND_CANCELLED_BOOKINGS =
  "booking-refund/cancelled-bookings";
export const BOOKING_REFUND_DETAIL = "booking-refund/detail";
export const CREATE_BOOKING_REFUND = "booking-refund/create";
export const UPDATE_BOOKING_REFUND_STATUS = "booking-refund/update-status";
export const BOOKING_REFUND_RAZORPAY = "booking-refund/razorpay-refund";
export const DELETE_BOOKING_REFUND = "booking-refund/destroy";

// Reporting API
export const REPORTING = "all-reports";
export const REPORTING_V2 = "all-reports-v2";
export const BOOKING_REPORT = "booking-reports";
export const NIGHT_AUDIT_REPORT = "night-audit";
export const NIGHT_AUDIT_GEN_REPORT = "night-audit/generate";
export const NIGHT_AUDIT_PDF = API_URL + "/night-audit/";

// Product API
export const ALL_PRODUCT = "product";
export const ACTIVE_PRODUCT = "product/active";
export const PRODUCT_BY_ID = "product/detail";
export const CREATE_PRODUCT = "product/create";
export const EDIT_PRODUCT = "product/update";
export const EDIT_STATUS_PRODUCT = "product/status/update";
export const DELETE_PRODUCT = "product/destroy";

// Order API
export const ALL_ORDER = "order";
export const ORDER_BY_ID = "order/detail";
export const CREATE_ORDER = "order/create";
export const ORDER_PAY = "order/pay";
export const ORDER_PAY_VERIFY = "order/pay_verify";

// Variant API
export const ALL_VARIANT = "variant";
export const VARIANT_DETAIL_BY_ID = "varByID";
export const VARIANT_BY_PRODUCT_ID = "getVarById";
export const CREATE_VARIANT = "createVariant";
export const EDIT_VARIANT = "updateVariant";
export const DELETE_VARIANT = "deleteVariant";

// Setting API
export const CREATE_SETTING = "system-setting/manage";
export const SETTING = "system-setting";

// WhatsApp Module API
export const WHATSAPP_CONFIG = "whatsapp/config";
export const WHATSAPP_LOGS = "whatsapp/logs";
export const WHATSAPP_RECHARGE_HISTORY = "whatsapp/recharge/history";
export const WHATSAPP_RECHARGE_ORDER = "whatsapp/recharge/order";
export const WHATSAPP_RECHARGE_VERIFY = "whatsapp/recharge/verify";
export const WHATSAPP_MESSAGE_SENDING = "whatsapp/message-sending";
export const WHATSAPP_SEND_BOOKING_MESSAGE = "whatsapp/send-booking-message";
export const WHATSAPP_MESSAGE_TYPES = "whatsapp/message-types";
export const WHATSAPP_SEND_MANUAL_MESSAGE = "whatsapp/send-manual-message";

// Wishlist API
export const USER_WISE_WISHLIST = "wishlist";
export const REMOVE_TO_WISHLIST = "deleteWishlist";
export const CLEAR_THE_WISHLIST = "clearTheWishlist";

// Hom-Package  API
export const ALL_HOMEPACKAGE = "homePackage";
export const HOMEPACKAGE_BY_ID = "homePackageByID";
export const CREATE_HOMEPACKAGE = "createHomePackage";
export const EDIT_HOMEPACKAGE = "updateHomePackage";
export const DELETE_HOMEPACKAGE = "deleteHomePackage";

// Coupon  API
export const ALL_COUPON = "allCoupons";
export const COUPON_BY_ID = "couponByID";
export const CREATE_COUPON = "createCoupons";
export const EDIT_COUPON = "updateCoupons";
export const DELETE_COUPON = "deleteCoupons";

// On-Boarding  API
export const ALL_ONBORDING = "onBoardings";
export const ONBORDING_BY_ID = "onBoardingByID";
export const CREATE_ONBORDING = "createOnBoarding";
export const EDIT_ONBORDING = "updateOnBoarding";
export const DELETE_ONBORDING = "deleteOnBoarding";

// Notification Content  API
export const ALL_NOTIFICATION = "notification";
export const CREATE_NOTIFICATION = "createNotification";
export const EDIT_NOTIFICATION = "updateNotification";
export const DELETE_NOTIFICATION = "deleteNotification";

// Cart API
export const USER_WISE_CART = "cart";
export const REMOVE_TO_CART = "deleteCart";
export const CLEAR_THE_CART = "clearUserCart";

// Chanel Manger API
export const CHANEL_SYNC_INVENTORY = "chanel/sync-inventory";
export const CHANEL_SYNC_RATE = "chanel/sync-rates";
export const CHANEL_SYNC_NO_SHOW = "chanel/sync-no-shows";
// Rate Plan API
export const RATE_PLAN = "rate-plans";
export const RATE_PLAN_CREATE = "rate-plans/create";
export const RATE_PLAN_UPDATE = "rate-plans/update";
export const RATE_PLAN_EDIT = "rate-plans/edit";
export const RATE_PLAN_TRUNCATE = "rate-plans/truncate";

export const GET_ALL_AIOSELL_LOGS = "aiosell-logs";
export const DELETE_LOGS_BY_DATE = "aiosell-logs/delete-by-date";
export const TRUNCATE_LOGS = "aiosell-logs/truncate";

// Laundry Vendor
export const ALL_VENDOR = "vendor";
export const CREATE_VENDOR = "vendor/create";
export const UPDATE_VENDOR = "vendor/update";
export const DELETE_VENDOR = "vendor/destroy";
export const VENDOR_BY_ID = "vendor/detail";

export const ALL_LAUNDRY_ITEM = "laundry-item";
export const CREATE_LAUNDRY_ITEM = "laundry-item/create";
export const UPDATE_LAUNDRY_ITEM = "laundry-item/update";
export const DELETE_LAUNDRY_ITEM = "laundry-item/destroy";
export const LAUNDRY_ITEM_BY_ID = "laundry-item/detail";

export const CREATE_LAUNDRY_OUT = "laundry-out/create";
export const ALL_LAUNDRY_OUT = "laundry-out";
export const LAUNDRY_OUT_BY_ID = "laundry-out/detail";

export const LAUNDRY_IN_DETAIL = "laundry-in/detail";
export const CREATE_LAUNDRY_IN = "laundry-in/create";

export const ALL_LAUNDRY_PAYMENT = "laundry-payment";
export const CREATE_LAUNDRY_PAYMENT = "laundry-payment/create";

// Reports
export const VENDOR_OUTSTANDING_REPORT = "report/vendor-outstanding";
export const VENDOR_LEDGER_REPORT = "report/vendor-ledger";
export const STOCK_REPORT = "laundry/stock";

export const STOCK_LEDGER = "laundry/stock-ledger";
export const STOCK_ADJUST = "laundry/stock-adjust";

export const KITCHEN_ITEM_LIST = "kitchen/item";
export const KITCHEN_ITEM_CREATE = "kitchen/item/create";
export const KITCHEN_ITEM_DETAIL = "kitchen/item/detail";
export const KITCHEN_ITEM_UPDATE = "kitchen/item/update";
export const KITCHEN_ITEM_DELETE = "kitchen/item/destroy";

export const KITCHEN_PURCHASE_LIST = "kitchen/purchase";
export const KITCHEN_PURCHASE_CREATE = "kitchen/purchase/create";
export const KITCHEN_PURCHASE_DETAIL = "kitchen/purchase/detail";
export const KITCHEN_PURCHASE_DELETE = "kitchen/purchase/destroy";

export const KITCHEN_PURCHASE_RETURN_LIST = "kitchen/purchase-return";
export const KITCHEN_PURCHASE_RETURN_CREATE = "kitchen/purchase-return/create";
export const KITCHEN_PURCHASE_RETURN_DETAIL = "kitchen/purchase-return/detail";
export const KITCHEN_PURCHASE_RETURN_DELETE = "kitchen/purchase-return/destroy";

export const KITCHEN_PR_LIST = "kitchen/purchase-request";
export const KITCHEN_PR_CREATE = "kitchen/purchase-request/create";
export const KITCHEN_PR_DETAIL = "kitchen/purchase-request/detail";
export const KITCHEN_PR_UPDATE_STATUS =
  "kitchen/purchase-request/update-status";
export const KITCHEN_PR_DELETE = "kitchen/purchase-request/destroy";

export const KITCHEN_ISSUE_CREATE = "kitchen/issue/create";
export const KITCHEN_ISSUE_LIST = "kitchen/issue";
export const KITCHEN_ISSUE_DETAIL = "kitchen/issue/detail";
export const KITCHEN_ISSUE_UPDATE = "kitchen/issue/update";
export const KITCHEN_GROUP_ISSUE_LIST = "kitchen/report/issue-grouped";
export const KITCHEN_ISSUE_DELETE = "kitchen/issue/destroy";
export const KITCHEN_ISSUE_INVENTORY = "kitchen/issue/inventory";

export const KITCHEN_ISSUE_REPORT = "kitchen/report/issue";
export const KITCHEN_STOCK_REPORT = "kitchen/report/stock";
export const KITCHEN_PURCHASE_REPORT = "kitchen/report/purchase";
export const KITCHEN_LOW_STOCK_REPORT = "kitchen/report/low-stock";
export const KITCHEN_EXP_STOCK_REPORT = "kitchen/report/expiry-stock-alert";
export const KITCHEN_PURCHASE_REQUEST_REPORT =
  "kitchen/report/purchase-request-report";
export const KITCHEN_GENERATE_STOCK_REPORT = "kitchen/report/gen-stock-report";
export const KITCHEN_DAILY_STOCK_REPORT = "kitchen/report/stock-reports";

export const APP_PAGE_LIST = "app-pages";
export const APP_PAGE_SYNC = "app-pages/sync";
export const APP_PAGE_CREATE = "app-pages/create";
export const APP_PAGE_TOGGLE = "app-pages/toggle";
export const APP_PAGE_DELETE = "app-pages/destroy";

export const SMART_PRICE = "smart-price";

export const SMART_PRICE_LIST = SMART_PRICE;
export const SMART_PRICE_ROOM = SMART_PRICE + "/room";
export const SMART_PRICE_GENERATE = SMART_PRICE + "/generate";

export const SMART_PRICE_PENDING = SMART_PRICE + "/suggestions/pending";
export const SMART_PRICE_APPROVED = SMART_PRICE + "/suggestions/approved";
export const SMART_PRICE_REJECTED = SMART_PRICE + "/suggestions/rejected";
export const SMART_PRICE_EXPIRED = SMART_PRICE + "/suggestions/expired";

export const SMART_PRICE_APPROVE = SMART_PRICE + "/suggestions/approve";
export const SMART_PRICE_REJECT = SMART_PRICE + "/suggestions/reject";
export const SMART_PRICE_BULK_APPROVE = SMART_PRICE + "/suggestions/bulk-approve";
export const SMART_PRICE_BULK_REJECT = SMART_PRICE + "/suggestions/bulk-reject";

export const SMART_PRICE_CALENDAR = SMART_PRICE + "/demand-calendar";
export const SMART_PRICE_GENERATION_HISTORY = SMART_PRICE + "/generation-history";
export const SMART_PRICE_CHANGE_HISTORY = SMART_PRICE + "/change-history";

export const SMART_PRICE_DASHBOARD = SMART_PRICE + "/dashboard-widget";

export const SMART_PRICE_PRICING_RULES = SMART_PRICE + "/pricing-rules";
export const SMART_PRICE_CREATE_PRICING_RULE = SMART_PRICE + "/pricing-rules/store";
export const SMART_PRICE_UPDATE_PRICING_RULE = SMART_PRICE + "/pricing-rules/update";
export const SMART_PRICE_DELETE_PRICING_RULE = SMART_PRICE + "/pricing-rules/delete";

export const FESTIVALS = "festivals";
export const FESTIVAL_STORE = "festivals/store";
export const FESTIVAL_UPDATE = "festivals/update";
export const DELETE_FESTIVAL = "festivals/delete";
export const GENERATE_FESTIVAL = "festivals/generate";
